import { createAction, props } from "@ngrx/store";
import { ISkillChampion } from "@skills-app/models/skill-champion";

const prefix = "[Skill Champion API]";

export const requestCurrentSkillChampions = createAction(
  `${prefix} Request Current Champions`,
  props<{ skillNodeId: string }>(),
);
export const requestCurrentSkillChampionsSuccess = createAction(
  `${prefix} Request Current Champions Success`,
  props<{ skillChampions: ISkillChampion[] }>(),
);
export const requestCurrentSkillChampionsError = createAction(
  `${prefix} Request Current Champions Error`,
);

export const upsertSkillChampions = createAction(
  `${prefix} Request Upsert Current Champions`,
  props<{ skillNodeId: string; skillChampions: ISkillChampion[] }>(),
);
export const upsertSkillChampionsSuccess = createAction(
  `${prefix} Request Upsert Current Champions Success`,
  props<{ skillChampions: ISkillChampion[] }>(),
);
export const upsertSkillChampionsError = createAction(
  `${prefix} Request Upsert Current Champions Error`,
);
